const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "769px",
    height: "505px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.947
    },
    fill: "#8f8f8f",
    d: "M 43.5,-0.5 C 270.833,-0.5 498.167,-0.5 725.5,-0.5C 749.039,2.37368 763.373,15.3737 768.5,38.5C 768.5,181.167 768.5,323.833 768.5,466.5C 763.712,485.956 751.712,498.623 732.5,504.5C 500.167,504.5 267.833,504.5 35.5,504.5C 16.2923,498.626 4.29227,485.96 -0.5,466.5C -0.5,323.833 -0.5,181.167 -0.5,38.5C 5.39996,15.5996 20.0666,2.59959 43.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 40.5,7.5 C 269.5,7.33333 498.5,7.5 727.5,8C 744.346,11.1784 755.18,21.0117 760,37.5C 760.667,180.167 760.667,322.833 760,465.5C 756.202,482.631 745.702,493.131 728.5,497C 498.833,497.667 269.167,497.667 39.5,497C 22.3244,493.158 11.8244,482.658 8,465.5C 7.33333,322.833 7.33333,180.167 8,37.5C 13.0031,20.9904 23.8365,10.9904 40.5,7.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000007",
    d: "M 493.5,83.5 C 555.204,125.562 585.87,184.229 585.5,259.5C 582.294,292.967 572.461,324.634 556,354.5C 551.781,361.772 546.948,368.605 541.5,375C 542.056,375.383 542.389,375.883 542.5,376.5C 533.109,385.389 523.776,394.555 514.5,404C 460.261,447.887 398.927,462.054 330.5,446.5C 279.21,431.707 239.543,401.707 211.5,356.5C 211.657,355.127 211.49,353.793 211,352.5C 186.967,309.122 178.8,262.789 186.5,213.5C 187.817,204.22 190.15,195.22 193.5,186.5C 194.376,186.631 195.043,186.298 195.5,185.5C 217.878,126.288 258.712,85.6216 318,63.5C 319.03,63.1639 319.53,62.4972 319.5,61.5C 331.043,56.9484 343.043,54.2818 355.5,53.5C 403.671,48.0621 448.337,57.8954 489.5,83C 490.793,83.49 492.127,83.6567 493.5,83.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1d1b20",
    d: "M 493.5,83.5 C 492.127,83.6567 490.793,83.49 489.5,83C 448.337,57.8954 403.671,48.0621 355.5,53.5C 405.239,46.248 451.239,56.248 493.5,83.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#201e23",
    d: "M 319.5,61.5 C 319.53,62.4972 319.03,63.1639 318,63.5C 258.712,85.6216 217.878,126.288 195.5,185.5C 195.043,186.298 194.376,186.631 193.5,186.5C 216.228,125.439 258.228,83.7722 319.5,61.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7f7f7",
    d: "M 365.5,172.5 C 373.167,172.5 380.833,172.5 388.5,172.5C 388.167,211.172 388.5,249.839 389.5,288.5C 395.128,290.765 400.794,292.931 406.5,295C 407.428,295.388 408.095,296.055 408.5,297C 405.893,304.515 402.726,311.682 399,318.5C 390.891,314.862 382.725,311.362 374.5,308C 370.942,306.108 368.442,303.275 367,299.5C 365.528,257.206 365.028,214.873 365.5,172.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1e73b",
    d: "M 459.5,197.5 C 495.718,194.755 519.718,210.422 531.5,244.5C 522.809,245.324 514.142,246.324 505.5,247.5C 500.746,239.577 494.412,233.077 486.5,228C 477.457,224.124 468.29,223.624 459,226.5C 454.91,218.653 451.077,210.653 447.5,202.5C 451.198,200.047 455.198,198.38 459.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfcfc",
    d: "M 291.5,198.5 C 323.346,197.668 345.18,212.001 357,241.5C 357.798,243.259 357.631,244.926 356.5,246.5C 320.041,262.597 283.541,278.597 247,294.5C 242.082,287.99 238.749,280.657 237,272.5C 232.903,239.184 246.07,215.684 276.5,202C 281.545,200.425 286.545,199.259 291.5,198.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#009bd2",
    d: "M 431.5,210.5 C 436.834,217.856 441.834,225.523 446.5,233.5C 431.324,252.214 431.991,270.38 448.5,288C 444.805,295.893 440.472,303.393 435.5,310.5C 413.556,293.854 405.056,271.854 410,244.5C 413.891,231.041 421.058,219.708 431.5,210.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#04040b",
    d: "M 289.5,225.5 C 302.762,223.671 314.095,227.337 323.5,236.5C 303.492,245.947 283.159,254.613 262.5,262.5C 262.977,243.858 271.977,231.525 289.5,225.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e74123",
    d: "M 505.5,261.5 C 514.5,261.5 523.5,261.5 532.5,261.5C 528.55,298.948 507.717,318.948 470,321.5C 465.12,321.429 460.287,320.929 455.5,320C 453.714,319.804 452.381,318.971 451.5,317.5C 454.558,309.717 457.892,302.05 461.5,294.5C 478.985,296.674 492.485,290.341 502,275.5C 503.893,270.993 505.059,266.327 505.5,261.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbfbfb",
    d: "M 321.5,285.5 C 328.071,291.404 334.404,297.737 340.5,304.5C 317.348,325.28 292.181,327.946 265,312.5C 264.333,311.5 264.333,310.5 265,309.5C 269.167,303.333 273.333,297.167 277.5,291C 282.196,291.894 286.863,293.228 291.5,295C 302.853,295.937 312.853,292.77 321.5,285.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#201f23",
    d: "M 186.5,213.5 C 178.8,262.789 186.967,309.122 211,352.5C 211.49,353.793 211.657,355.127 211.5,356.5C 185.564,311.882 177.231,264.215 186.5,213.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#201e23",
    d: "M 585.5,259.5 C 583.19,303.177 568.856,342.177 542.5,376.5C 542.389,375.883 542.056,375.383 541.5,375C 546.948,368.605 551.781,361.772 556,354.5C 572.461,324.634 582.294,292.967 585.5,259.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1f1d22",
    d: "M 542.5,376.5 C 501.543,427.308 448.21,452.975 382.5,453.5C 364.621,454.22 347.288,451.887 330.5,446.5C 398.927,462.054 460.261,447.887 514.5,404C 523.776,394.555 533.109,385.389 542.5,376.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElo);
export default __webpack_public_path__ + "static/media/elo.ff92b45849b5e2e5f6f2591623321dfa.svg";
export { ForwardRef as ReactComponent };